import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { icons } from "../scenes/stack/environment/icons/iconExport";

const LabelChip = ({
  text,
  color = null,
  size = "M",
  type = "outline",
  onClick = null,
  textColor = null,
  sx = {},
}) => {
  const colors = useColors();

  const sizeMapping = {
    S: {
      height: "20px",
      borderRadius: "10px",
      iconSize: "12px",
    },
    M: {
      height: "24px",
      borderRadius: "12px",
      iconSize: "16px",
    },
    L: {
      height: "30px",
      borderRadius: "16px",
      iconSize: "18px",
    },
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="6px"
      border={
        type === "outline"
          ? `0.5px solid ${colors.button_outlined_inherit_enabled_stroke}`
          : type === "noBorder"
          ? " none"
          : "none"
      }
      onClick={onClick}
      sx={{
        height: sizeMapping[size].height,
        minWidth: "min-content",
        borderRadius: sizeMapping[size].borderRadius,
        paddingX: "8px",
        cursor: onClick ? "pointer" : "default",
        ...sx,
      }}
    >
      <SvgToIcon
        IconLogo={icons.LabelIcon}
        width={sizeMapping[size].iconSize}
        height={sizeMapping[size].iconSize}
        style={{ color: colors[color] || colors.tag_label_1 }}
      />
      <Typography variant="caption" color={textColor || colors.text_secondary}>
        {text}
      </Typography>
    </Box>
  );
};

export default LabelChip;
